/* eslint-disable no-console */
/* eslint-disable func-names */
import React, { useEffect, useMemo, useState } from 'react';
import { Row, Container, Col, Button, Nav } from 'react-bootstrap';
import ProgressBar from 'react-bootstrap/ProgressBar';
import Modal from 'react-bootstrap/Modal';
import Wallet from '@project-serum/sol-wallet-adapter';
import { Connection, clusterApiUrl } from '@solana/web3.js';
import Navbar from './components/Navbar';
import './App.scss';
import Hero from './components/Hero';
import Features from './components/Features';
import FourTiers from './components/Four_Tiers';
import Pools from './components/Pools';
import Partners from './components/Partners';
import Footer from './components/Footer';
import ModalLogo from './img/Modals/logo-wihtout-label.svg';
import Line from './img/Modals/line.svg';
import RoadMap from './components/RoadMap';
import Team from './components/Team';
import Ecosystem from './components/Ecosystem';
import {
    ExecuteTokenSaleWithUserWallet,
    createAssociatedTokenAccountForSolr
} from './utils/cli/token-sale-test';
import WhiteListBanner from './banners/WhiteListBanner';
import LotteryBanner from './banners/LotteryBanner';
import PurchaseBanner from './banners/PurchaseBanner';
import Routes from './routes'
import { Route, Switch } from 'react-router-dom';
import UpdateForm from './components/routeComponents/UpdateForm';
import { getStateFromUrl } from './utils/helper';
function toHex(buffer) {
    return Array.prototype.map.call(buffer, (x) => `00${x.toString(16)}`.slice(-2)).join('');
}

async function InitAndFund(selectedWallet) {
    // do nothing...
}

const themeToggle = () => {
    const body = document.getElementsByTagName('body')[0];
    body.classList.toggle('dark-theme');
};

const darkTheme = () => {
    const body = document.getElementsByTagName('body')[0];
    body.classList.toggle('dark-theme');
};

const lightTheme = () => {
    const body = document.getElementsByTagName('body')[0];
    body.classList.toggle('dark-theme');
};

const darkThemeDefault = () => {
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('dark-theme');
};

function App() {
    const network = clusterApiUrl('devnet');
    const [providerUrl, setProviderUrl] = useState('https://www.sollet.io');
    const connection = useMemo(() => new Connection(network), [network]);
    const urlWallet = useMemo(() => new Wallet(providerUrl, network), [providerUrl, network]);

    console.log(network)

    const [selectedWallet, setSelectedWallet] = useState(undefined);
    const [, setConnected] = useState(false);
    const [walletAddress, setWalletAddress] = useState('');

    useEffect(() => {
        if (selectedWallet) {
            selectedWallet.on('connect', () => {
                setConnected(true);
                console.log('Connected to wallet ' + selectedWallet.publicKey.toBase58());
                console.log('selected wallet', selectedWallet)
                setWalletAddress(selectedWallet.publicKey.toBase58());
                console.log('connection ' + connection.network);
            });
            selectedWallet.on('disconnect', () => {
                setConnected(false);
                console.log('Disconnected from wallet');
                setWalletAddress('');
            });
            selectedWallet.connect();
            return () => {
                selectedWallet.disconnect();
            };
        }
        return null;
    }, [selectedWallet]);

    function connectToWallet() {
        setSelectedWallet(urlWallet);
    }

    const [navColor, setNavColor] = React.useState(false);
    const [showModal, setShowModal] = React.useState(false);
    const [showMenu, _setShowMenu] = React.useState(false);
    const [activeKey, setActiveKey] = React.useState('1');

    const changeNavbarColor = () => {
        if (window.scrollY > 20) {
            setNavColor(true);
        } else {
            setNavColor(false);
        }
    };

    const scroll = () => {
        window.scrollTo(0, 20);
    };

    React.useEffect(() => {
        window.addEventListener('scroll', changeNavbarColor);
    }, []);

    React.useEffect(() => {
        darkThemeDefault();
    }, []);

    const setShowMenu = (show) => {
        document.body.classList.toggle('side-menu');
        _setShowMenu(show);
    };

    const setKey = (key) => {
        setActiveKey(key);
    };

    const state = getStateFromUrl();
    console.log(state)

    // CUSTOM CURSOR START
    const customCursor = () => {
        const cursor = document.querySelector('.cursor');
    
        document.addEventListener('mousemove', e => {
        //   console.log(e)
          cursor.setAttribute("style", "top: "+(e.pageY - 10)+"px; left: "+(e.pageX - 10)+"px;")
        })
    
        document.addEventListener('click', () => {
          cursor.classList.add("expand");
    
          setTimeout(() => {
            cursor.classList.remove("expand");
          }, 500)
        })
      }
    
      React.useEffect(() => {
        customCursor();
      },[])
      // CUSTOM CURSOR END

      const isUpdate = (window.location.pathname.indexOf('/update/') && window.location.pathname.indexOf('/update')) !== -1;
    

    return (
        <div className="App">
            { !isUpdate && (

            <>
            <div className="cursor"></div>
            <Navbar
                navColor={navColor}
                setShowModal={setShowModal}
                setShowMenu={setShowMenu}
                themeToggle={themeToggle}
                navState={state}
                walletAddress={walletAddress}
            />
            { state === 'whitelist' && <WhiteListBanner connectToWallet={connectToWallet} createAssociatedTokenAccountForSolr={createAssociatedTokenAccountForSolr} selectedWallet={selectedWallet} connection={connection} walletAddress={walletAddress} ExecuteTokenSaleWithUserWallet={ExecuteTokenSaleWithUserWallet}/> }
            { state === 'lottery' && <LotteryBanner connectToWallet={connectToWallet} createAssociatedTokenAccountForSolr={createAssociatedTokenAccountForSolr} selectedWallet={selectedWallet} connection={connection} walletAddress={walletAddress} ExecuteTokenSaleWithUserWallet={ExecuteTokenSaleWithUserWallet}/> }
            { state === 'purchase' && <PurchaseBanner connectToWallet={connectToWallet} createAssociatedTokenAccountForSolr={createAssociatedTokenAccountForSolr} selectedWallet={selectedWallet} connection={connection} walletAddress={walletAddress} ExecuteTokenSaleWithUserWallet={ExecuteTokenSaleWithUserWallet}/> }
            
            <Hero darkTheme={darkTheme} lightTheme={lightTheme}  themeToggle={themeToggle} connectToWallet={connectToWallet} createAssociatedTokenAccountForSolr={createAssociatedTokenAccountForSolr} selectedWallet={selectedWallet} connection={connection} walletAddress={walletAddress} ExecuteTokenSaleWithUserWallet={ExecuteTokenSaleWithUserWallet} navState={state}/>
            <Features />
            <FourTiers />
            <Pools />
            <Ecosystem />
            <RoadMap />
            <Partners />            
            <Team />
            <Footer scroll={scroll} />
            </>
            )
            }

            {/* <Routes /> */}
            { isUpdate && (
                <Routes />
                // <> 
                // <div className="cursor"></div>
                // <Switch>
                //     <Route path="/update">
                //         <UpdateForm />
                //     </Route>
                // </Switch>   
                // </>
            )
            }
             
            <Modal
                id="connect-modal"
                centered
                size="lg"
                show={showModal}
                onHide={() => setShowModal(false)}
                dialogClassName="modal-90w"
                aria-labelledby="example-custom-modal-styling-title">
                <Modal.Header closeButton />
                <Modal.Body>
                    <Container>
                        <Row className="body-content">
                            <Col xs={12} md={6} lg={6}>
                                <Container fluid>
                                    <div className="padding-1">
                                        <img
                                            className="modal-logo"
                                            src={ModalLogo}
                                            alt="modalLogo"
                                        />
                                        <span className="logo-label ml-3">Solrazr</span>
                                        <div className="mt-2">
                                            <a className="ancor-style" href="/">
                                                www.solrazr.com
                                            </a>
                                        </div>
                                    </div>
                                    <div className="padding-2">
                                        <span className="span-1">Your allocation expires by</span>
                                        <br />
                                        <span className="span-2">2 hrs 30 min 23sec</span>
                                        <br />
                                        <span className="span-1">(21st May 2021 14:30 UTC)</span>
                                    </div>
                                    <div className="padding-2">
                                        <span className="span-1">72% Progress</span>
                                        <br />
                                        <span className="span-2">
                                            <ProgressBar
                                                className="progress-bar"
                                                variant="success"
                                                now={72}
                                            />
                                        </span>
                                        <h1 className="span-2 mt-2">
                                            $ 60,540 / $ 100,000
                                            <span className="span-1 ml-5">2460 Backers</span>
                                        </h1>
                                    </div>
                                    <div className="padding-3">
                                        <span className="span-1">Conversion</span>
                                        <br />
                                        <span className="span-2">
                                            1 SOLR = $0.075 = 0.0000375 ETH
                                        </span>
                                    </div>
                                </Container>
                            </Col>
                            <Col xs={12} md={6} lg={6}>
                                <Container>
                                    <Row>
                                        <Col sm={12} md={12} className="your-balance-col">
                                            1 ETH = $2000
                                            <span className="ml-2">
                                                <img src={Line} alt="line" />
                                            </span>
                                            <span className="ml-2">Your Balance: 23.34 ETH</span>
                                        </Col>
                                        <Col md={12} className="mt-2 pad-right">
                                            <div className="dotted-border">
                                                <div className="div-style">
                                                    <h3
                                                        className="style-purchase"
                                                        style={{ paddingTop: '40px' }}>
                                                        Purchase Amount
                                                    </h3>
                                                    <Row>
                                                        <Col
                                                            xs={9}
                                                            md={9}
                                                            style={{
                                                                paddingLeft: '58px'
                                                            }}>
                                                            <Row className="border-col">
                                                                <Col
                                                                    xs={5}
                                                                    md={5}
                                                                    className="max-div">
                                                                    Max
                                                                </Col>
                                                                <Col
                                                                    xs={7}
                                                                    md={7}
                                                                    className="text-postion-style">
                                                                    0.25
                                                                    <span className="text-postion-style-1">
                                                                        {' '}
                                                                        ETH
                                                                    </span>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                        <Col xs={3} md={3}>
                                                            <h5
                                                                className="style mt-2"
                                                                style={{ marginLeft: '-20px' }}>
                                                                ($500)
                                                            </h5>
                                                        </Col>
                                                    </Row>
                                                    <h5 className="min-style">
                                                        Min: 0.05 ETH Max: 0.25 ETH
                                                    </h5>
                                                    <div className="gray-div">
                                                        <h5 className="text-setting">
                                                            You will receive
                                                            <span className="solr-style">
                                                                {' '}
                                                                1000 $SOLR
                                                            </span>
                                                        </h5>
                                                        <div className="purchase-padding">
                                                            <Button className="purchase-button">
                                                                Purchase
                                                            </Button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </Container>
                            </Col>
                        </Row>
                    </Container>
                </Modal.Body>
            </Modal>

            {/* Menu start */}
            <>
                <Modal
                    show={showMenu}
                    onHide={() => setShowMenu(false)}
                    dialogClassName="modal-90w"
                    className="menu-model"
                    animation={false}
                    aria-labelledby="example-custom-modal-styling-title">
                    <Modal.Header closeButton className="menu-model-header" />
                    <Modal.Body>
                        <Nav
                            activeKey={activeKey}
                            className="menu-links-div"
                            style={{ display: 'block' }}>
                            <div>
                                <Nav.Item>
                                    <Nav.Link
                                        eventKey="1"
                                        onClick={() => {
                                            setKey('1');
                                            setShowMenu(false);
                                        }}
                                        href="#Home">
                                        Home
                                    </Nav.Link>
                                </Nav.Item>
                            </div>
                            <div className="menu-link">
                                <Nav.Item>
                                    <Nav.Link
                                        eventKey="2"
                                        onClick={() => {
                                            setKey('2');
                                            setShowMenu(false);
                                        }}
                                        href="#Features">
                                        Features
                                    </Nav.Link>
                                </Nav.Item>
                            </div>
                            <div className="menu-link">
                                <Nav.Item onClick={scroll}>
                                    <Nav.Link
                                        eventKey="3"
                                        onClick={() => {
                                            setKey('3');
                                            setShowMenu(false);
                                        }}
                                        href="#Allocation">
                                        Allocation
                                    </Nav.Link>
                                </Nav.Item>
                            </div>
                            <div className="menu-link">
                                <Nav.Item>
                                    <Nav.Link
                                        eventKey="4"
                                        onClick={() => {
                                            setKey('4');
                                            setShowMenu(false);
                                        }}
                                        href="#Pools">
                                        Pools
                                    </Nav.Link>
                                </Nav.Item>
                            </div>
                            <div className="menu-link">
                                <Nav.Item>
                                    <Nav.Link
                                        eventKey="5"
                                        onClick={() => {
                                            setKey('5');
                                            setShowMenu(false);
                                        }}
                                        href="#Ecosystem">
                                        Ecosystem
                                    </Nav.Link>
                                </Nav.Item>
                            </div>
                            <div className="menu-link">
                                <Nav.Item>
                                    <Nav.Link
                                        eventKey="6"
                                        onClick={() => {
                                            setKey('6');
                                            setShowMenu(false);
                                        }}
                                        href="#RoadMap1">
                                        Roadmap
                                    </Nav.Link>
                                </Nav.Item>
                            </div>
                            <div className="menu-link">
                                <Nav.Item>
                                    <Nav.Link
                                        eventKey="7"
                                        onClick={() => {
                                            setKey('7');
                                            setShowMenu(false);
                                        }}
                                        href="#Partners">
                                        Partners
                                    </Nav.Link>
                                </Nav.Item>
                            </div>
                            <div className="menu-link">
                                <Nav.Item>
                                    <Nav.Link
                                        eventKey="8"
                                        onClick={() => {
                                            setKey('8');
                                            setShowMenu(false);
                                        }}
                                        href="#Team">
                                        Team
                                    </Nav.Link>
                                </Nav.Item>
                            </div>
                        </Nav>
                    </Modal.Body>
                </Modal>
            </>
        </div>
    );
}

export default App;
